import { AnalyticsMetaKeys as key } from '../../../../../services/analytics/formatters/meta-keys'

export interface IUserAttrFormatter {

    format(obj: any): object
}

export class UserAttrFormatter implements IUserAttrFormatter {

    public format(data: any): object {
        const obj: any = {}
        if (data) {
            if (data.loc) {
                obj[key.BTN_LOC] = String(data.loc)
            }
            if (data.viewSignRegMod) {
                obj[key.USER_VIEW_SIGN_REG_MODULE] = String(data.viewSignRegMod)
            }
            if (data.status) {
                obj[key.USER_ACNT_STATUS] = String(data.status)
            }
            if (data.method) {
                obj[key.USER_SIGNIN_MTHD] = String(data.method)
            }
            if (String(data.tOf)) {
                obj[key.TRUE_FALSE] = String(data.tOf)
            }
        }
        return obj
    }
}
